module.exports = __webpack_public_path__ + "img/magasin-omni.001492f0.jpg";